export default {
  toasts: {
    success: 'Carta regalo riscattata con successo.',
    error: 'Riscatto della carta regalo non riuscito.',
  },
  title: 'Riscatta carta regalo',
  subtitle: "Inserisci il codice della carta regalo e l'importo da riscattare dal conto del cliente.",
  form: {
    amount: {
      label: 'Importo da riscattare',
    },
    code: {
      label: 'Codice carta regalo',
    },
  },
  buttons: {
    redeem: 'Riscatta',
    cancel: 'Annulla',
  },
};
